import React from "react";
import { useForm, SubmitHandler, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Input from "components/Input";
import { InventoryPayload } from "services/Inventory/inventoryInterface";
import { emailSchema } from "util/validation";

const schema = yup.object().shape({
  // CHANGE: yup's built-in .email() had no message and accepted
  // user@localhost; the shared schema applies the app-wide rule.
  issuedTo: emailSchema({ requiredMessage: "Email is required" }),
  rentStartDate: yup.string().required("Rent Start Date is required"),
  rentEndDate: yup.string().required("Rent End Date is required"),
  rentAmount: yup.number().required("Rent Amount is required"),
  paymentFrequency: yup.string().required("Payment Frequency is required"),
  issueDate: yup.string().required("Issue Date is required"),
  returnDate: yup.string().required("Return Date is required"),
});
interface AddProductProps {
  onClose: () => void;
}
const AddProduct = ({ onClose }: AddProductProps) => {
  const methods = useForm({ resolver: yupResolver(schema) });
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onSubmit: SubmitHandler<any> = (data: InventoryPayload) => {
    console.log(data);
    // inventoryManager
    //   .addInventoryData(data)
    //   .then((res) => {
    //     console.log("res :>> ", res);
        onClose();
    //   })
    //   .catch((err) => {
    //     console.log("err :>> ", err);
    //   });
  };

  return (
    <div className="bg-white  w-full  rounded-md" style={{ width: 900 }}>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <div className="grid gap-4 grid-cols-2">
            <Input name="issuedTo" type="email" label="Issued To" placeholder={`Eg : vijay@lirisoft.com`} />
            <Input name="rentStartDate" type="date" label="Rent Start Date" />
            <Input name="rentEndDate" type="date" label="Rent EndDate" />
            <Input name="rentAmount" type="number" label="Rent Amount" />
            <Input name="paymentFrequency" type="string" label="Payment Frequency" />
            <Input name="issueDate" type="date" label="Issue Date" />
            <Input name="returnDate" type="date" label="Return Date" />
          </div>

          <div className="flex justify-center">
            <button
              type="submit"
              className="bg-blue-500 text-white px-8 py-2 rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:border-blue-300"
            >
              Submit
            </button>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default AddProduct;
